import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';

import { OneFieldRegistrationAddress } from 'shared/ui/AddressFields/OneFieldRegistrationAddress/OneFieldRegistrationAddress';

export const PledgeAddress: FC<IFieldFactoryProps> = ({ isDisabled, ...props }) => {
  return (
    <OneFieldRegistrationAddress
      {...props}
      isDisabled={isDisabled}
    />
  );
};
